import { useAtom } from '@reatom/npm-react'
import { useState } from 'react'
import styled from 'styled-components'

import { useTranslation } from '@root/shared/localization'
import { UnderlineTabs } from '@root/shared/ui-kit'

import { tradingDrawerAtom } from '../../atoms'

import { PositionsViewTable } from './positions-view-table'

import type { ClassNameProps } from '@root/shared/react'

type PositionsViewProps = {} & ClassNameProps

type PositionsViewTab = 'positions' | 'all'

export const PositionsView: React.FC<PositionsViewProps> = ({ className }) => {
  const { t } = useTranslation()
  const [tab, setTab] = useState<PositionsViewTab>('positions')
  const [_tradingDrawer, setTradingDrawer] = useAtom(tradingDrawerAtom)

  return (
    <Root className={className}>
      <Header>
        <UnderlineTabs value={tab} onChange={setTab}>
          <UnderlineTabs.Tab value="positions">
            {t('trading.navigation.positions')}
          </UnderlineTabs.Tab>
          <UnderlineTabs.Tab
            value="all"
            onClick={() => setTradingDrawer('positions')}
          >
            {t('position.all-positions')}
          </UnderlineTabs.Tab>
        </UnderlineTabs>
      </Header>
      <Content>
        <PositionsViewTable />
      </Content>
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  grid-template-rows: auto minmax(0, 1fr);
`

const Content = styled.div`
  display: grid;
`

const Header = styled.div`
  --tab-padding-inline: 8px;

  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  background: var(--background-1);
  border-bottom: 1px solid var(--appearanceA-3);
  padding-inline: 12px;
`
